import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import CabinetRoadmapMain from "../../components/cabinetRoadmapMain";
import {useDispatch, useSelector} from "react-redux";
import {getRoadmap} from "../../store/cabinet/action";
import {useNavigate} from "react-router-dom";



const CabinetRoadmapPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        dispatch(getRoadmap());
    },[dispatch])

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetRoadmapMain/>
            </div>
        </section>
    );
};

export default CabinetRoadmapPage;
